exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.accountActivationCenter {\n  text-align: center;\n  display: block;\n}\n.accountActivationInput {\n  /* width: 100%; */\n  display: inline-block;\n  height: 100%;\n  vertical-align: middle;\n}\n.accountActivationInput > input {\n  /* width: 100%; */\n  height: 100%;\n}\n.modal {\n  width: 300px;\n  margin-left: -150px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-356ef03b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/popups/user/CMAccountActivation.vue
// module id = 1534
// module chunks = 2